import React, { Component } from 'react';
import './UsersCard.css';
import Card from '../../../components/card/Card';
import Label from '../../../components/label/Label';
import models from '../../../model/models';
import objUtils from '../../../utils/objUtils';
import utils from '../../../utils/utils';
import Input from '../../../inputs/input/Input';
import Button from '../../../components/button/Button';
import FontIcon from '../../../components/fontIcon/FontIcon';
import mainAPI from '../../../api/MainAPI';
import history from '../../../history';
import cloneDeep from 'lodash.clonedeep';
import CardHeader from '../../../components/cardHeader/CardHeader';
import toasts from '../../../utils/toasts';
import Icon from '../../../components/icon/Icon';
import ToggleSetting from "../../../components/toggleSetting/ToggleSetting";
import PrimaryButton from "../../../components/primaryButton/PrimaryButton";

class InviteUsersModal extends Component {
	constructor() {
		super();
		this.state = {
			user: {
				first_name: '',
				last_name: '',
				primary_email: ''
			},
			touched: {
				first_name: false,
				last_name: false,
				primary_email: false
			},
			displayArchived: false
		};
	}

	_handleInputChange = (field, value) => {
		const { user } = this.state;
		this.setState({
			user: { ...user, [field]: value }
		});
	};

	_inviteUser = async () => {
		const { onClose, getUsers } = this.props;
		this._touchAllFields();
		const { user, user: { primary_email, first_name, last_name } = {} } = this.state;
		if (primary_email && first_name && last_name) {
			const res = await mainAPI.user.invite(user);
			if (res && res.working_email_address === false) {
				return toasts.error(`We may not be able to deliver emails to ${primary_email}. Please make sure it exists and is typed correctly.`, 5000);
			}
			if (res.err) {
				return toasts.show('This email is already in your agency.');
			}
			toasts.show(`${first_name} was sent an email to set their password. It expires in 5 days.`, 4000);
			getUsers();
			onClose();
		}
	};

	_touchAllFields = () => {
		this.setState({
			touched: {
				first_name: true,
				last_name: true,
				primary_email: true
			}
		});
	};

	_handleTouched = (field) => {
		const { touched } = this.state;
		this.setState({
			touched: { ...touched, [field]: true }
		});
	};

	render() {
		const {
			user: { first_name, last_name, primary_email } = {},
			touched: { first_name: first_name_touched, last_name: last_name_touched, primary_email: email_touched } = {}
		} = this.state;
		const { onClose } = this.props;
		return (
			<div className="InviteUsersModal">
				<div className="InviteUsersModal-popup">
					<div className="InviteUsersModal-background" onClick={onClose} />
					<div className="InviteUsersModal-card">
						<div className="InviteUsersModal-card-header">
							<div />
							<Label large black className="InviteUsersModal-card-label">
								Invite
							</Label>
							<div className="InviteUsersModal-card-icon">
								<FontIcon
									tabIndex="0"
									className="InviteUsersModal-card-icon-font"
									onClick={onClose}
									name="icon-cancel"
									color="white"
								/>
							</div>
						</div>
						<div className="InviteUsersModal-card-inputs">
							<div className="InviteUsersModal-card-inputs-field">
								<Label className="InviteUsersModal-card-inputs-field-label" gray-medium />
								<Input
									onBlur={() => {
										this._handleTouched('primary_email');
									}}
									type="email"
									iconName="icon-email"
									className={`InviteUsersModal-card-inputs-field-input ${
										email_touched && !primary_email ? 'InviteUsersModal-card-inputs-field-error' : ''
									}`}
									placeholder="Email"
									required
									value={primary_email}
									onChange={(e) => {
										this._handleInputChange('primary_email', e);
									}}
								/>
							</div>
							<div className="InviteUsersModal-card-inputs-field">
								<Label className="InviteUsersModal-card-inputs-field-label" gray-medium />
								<Input
									onBlur={() => {
										this._handleTouched('first_name');
									}}
									iconName="icon-person"
									className={`InviteUsersModal-card-inputs-field-input ${
										first_name_touched && !first_name ? 'InviteUsersModal-card-inputs-field-error' : ''
									}`}
									placeholder="First Name"
									required
									value={first_name}
									onChange={(e) => {
										this._handleInputChange('first_name', e);
									}}
								/>
							</div>
							<div className="InviteUsersModal-card-inputs-field">
								<Label className="InviteUsersModal-card-inputs-field-label" gray-medium />
								<Input
									onBlur={() => {
										this._handleTouched('last_name');
									}}
									iconName="icon-person"
									className={`InviteUsersModal-card-inputs-field-input ${
										last_name_touched && !last_name ? 'InviteUsersModal-card-inputs-field-error' : ''
									}`}
									placeholder="Last Name"
									required
									value={last_name}
									onChange={(e) => {
										this._handleInputChange('last_name', e);
									}}
								/>
							</div>
						</div>
						<div className="InviteUsersModal-card-actions">
							<Button
								onClick={this._inviteUser}
								className="InviteUsersModal-card-actions-button"
								color="white"
								bg="blue"
							>
								Send Invite
							</Button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default class UsersCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			users: models.user.objs(),
			search: '',
			invite: false,
			sortColumn: 'last_active_on',
			sortDirection: 'descending'
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.user.onChange(this._getData);
	};

	componentWillUnmount = () => {
		models.user.unsubscribe(this.subscribeId);
	};

	_getData = () => {
		this.setState({ users: models.user.objs() });
	};

	_updateUsersList = async () => {
		let usersList = await mainAPI.user.all();
		this.setState({
			users: usersList
		});
	};

	_searchChange = (value) => {
		this.setState({ search: value });
	};

	_orderByColumn = (users) => {
		let descending = this.state.sortDirection === 'descending';
		let columnTypes = {
			last_active_on: 'datetime',
			primary_email: 'string',
			first_name: 'string'
		};
		return users.sort(utils.getSort(this.state.sortColumn, columnTypes[this.state.sortColumn], descending));
	};

	resendInvite = async (user_id, email) => {
		const response = await mainAPI.user.resend_invite({user_id})
		if(!response){
			return toasts.error('We were unable to resend the invite email.');
		}
		if(response.working_email_address === false){
			return toasts.error(`We may not be able to deliver emails to ${email}. Please make sure it exists and is typed correctly.`, 5000);
		}

		toasts.show(`We resent the invite email to ${email}`);
	}
	_renderUsers = () => {
		const {displayArchived} = this.state;
		let users = this.state.users || [];
		users = objUtils.to_array(cloneDeep(users));
		users = this._orderByColumn(users);
		let userDisplay = [];
		if (users.length < 1) return;
		for (let i in users) {
			let user = users[i] || { first_name: '', last_name: '' };
			let search = this.state.search || '';
			search = search.toLowerCase();
			if (
				(user.first_name || '').toLowerCase().indexOf(search) === -1 &&
				(user.last_name || '').toLowerCase().indexOf(search) === -1
			) {
				continue;
			}
			if(!displayArchived && isValidDate(user.inactive_after_date)){
				continue;
			}
			const disabledUserIcon = isValidDate(user.inactive_after_date) ? (
				<Label black>
					<Icon className="disabled icon" size="x-small" name={'block'} />
				</Label>
			) : (
				''
			);

			userDisplay.push(
				<div
					key={user.id}
					onClick={() => {
						history.navigate('/user/' + user.id);
					}}
          tabIndex={'0'}
					className="user-row"
				>
					<Label black>
						{disabledUserIcon}
						{`${user.first_name} ${user.last_name}`}
					</Label>
					{this._renderEmail(user)}
					{isValidDate(user.last_active_on) ? <Label black>
						{utils.display_date(user.last_active_on)}
					</Label> : <div><PrimaryButton center className={'resend-button'} onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
					   this.resendInvite(user.id, user.primary_email)
					}}>Resend Invite</PrimaryButton></div>}
				</div>
			);
		}
		return userDisplay;
	};

	_renderEmail = (user) => {
		if (!this.props.email) return;
		return (
			<Label black>
				{user.primary_email}
			</Label>
		);
	};

	_renderEmailHeader = () => {
		if (!this.props.email) return;
		return (
			<div className="column-header" onClick={this._handleColumnClickEmail} tabIndex={'0'}>
				<Label bold black>
					Email
				</Label>
				{this._renderIcon('primary_email')}
			</div>
		);
	};

	_renderIcon = (column) => {
		if (column !== this.state.sortColumn) return null;
		if (this.state.sortDirection === 'descending') return <FontIcon name="icon-chevron-down" />;
		return <FontIcon name="icon-chevron-up" />;
	};

	_openInviteUserModal = () => {
		this.setState({
			invite: true
		});
	};

	_closeInviteUserModal = () => {
		this.setState({
			invite: false
		});
	};

	_handleColumnClickDate = () => {
		this._handleColumnClick('last_active_on');
	};
	_handleColumnClickEmail = () => {
		this._handleColumnClick('primary_email');
	};

	_handleColumnClickName = () => {
		this._handleColumnClick('first_name');
	};

	_handleColumnClick = (column) => {
		let oppositeSort = { ascending: 'descending', descending: 'ascending' };
		if (this.state.sortColumn !== column) {
			return this.setState({ sortColumn: column, sortDirection: 'descending' });
		}
		this.setState({ sortDirection: oppositeSort[this.state.sortDirection] || 'descending' });
	};

	_renderLabelDate = () => {
		return (
			<div className="column-header" onClick={this._handleColumnClickDate} tabIndex={'0'}>
				<Label  bold black>
					Last Active
				</Label>
				{this._renderIcon('last_active_on')}
			</div>
		);
	};

	_renderLabelName = () => {
		return (
			<div className="column-header" onClick={this._handleColumnClickName} tabIndex={'0'}>
				<Label bold black>
					Name
				</Label>
				{this._renderIcon('first_name')}
			</div>
		);
	};

	_setDisplayArchived = ({target: {checked}}) => {
		this.setState({displayArchived: checked});
	}

	render() {
		const { invite } = this.state;
		let inviteUser = (
			<Button onClick={this._openInviteUserModal} className="top-row-right-button" color="white" bg="blue">
				Invite User
			</Button>
		);
		if (!this.props.invite) {
			inviteUser = null;
		}
		return (
			<Card half className="g-users-card">
				{invite && <InviteUsersModal getUsers={this._updateUsersList} onClose={this._closeInviteUserModal} />}
				<div className="top-row">
					<CardHeader>Users</CardHeader>
					<Input iconName="icon-search" onChange={this._searchChange} />
					{inviteUser}
				</div>
				<ToggleSetting className='view-disabled-users' label={'View Disabled'} labelPlacement='end' onChange={this._setDisplayArchived} />
				<div className="titles">
					{this._renderLabelName()}
					{this._renderEmailHeader()}
					{this._renderLabelDate()}
				</div>
				<div className="users-list">{this._renderUsers()}</div>
			</Card>
		);
	}
}
function isValidDate(d) {
	return d instanceof Date && !isNaN(d);
}



// WEBPACK FOOTER //
// ./src/pages/dashboardPage/usersCard/UsersCard.jsx